import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import ContactModal from '../../components/ContactModal';
// import { Link } from '@bd/bdcore-named-routes';
import { colors } from '../../styles';

const styles = css`
  width: 100%;
  position: relative;
  z-index: 1;
  .HeroImage_earlyAccessBanner {
    color: #FFFFFF;
    background-color: #DC1C4D;
    padding: 10px 25px;
    margin: 0;
    display: inline-block;
    margin: 0 0 30px 0;
    font-size: 20px;
    letter-spacing: 4px;
  }
  .HeroImage_logo {
    width: 325px;
    height: auto;
    margin: 0 0 15px 0;
  }
  .HeroImage_logoTagline {
    color: #c6cc27;
    font-weight: 700;
    font-size: 20px;
    margin: 0 0 30px 0;
    z-index: 1;
    @media (min-width: 992px) {
      font-size: 28px;
    }
  }
  .HeroImage_headlineWrapper {
    width: 100%;
    position: relative;
    z-index: 1;
    padding: 100px 15px 0 25px;
    background-position: bottom center;
    background-repeat: no-repeat;
    background-image: url('/images/hbt-bg.svg');
    background-size: cover;
    background-color: #111111;
    @media (min-width: 992px) {
      background-image: url('/images/HBT-Tease-Mockup.jpg');
      padding: 300px 0 90px 0;
      background-position: center right;
      background-size: cover;
    }
    ${'' /* &::before {
      content: '';
      display: block;
      position: absolute;
      left: -10vw;
      right: 40vw;
      top: 0;
      bottom: 0;
      background-color: #000000;
      opacity: .6;
      z-index: 0;
      transform: skewX(-10deg);
    } */}
    &::after {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background-color: #000000;
      opacity: .5;
      z-index: 0;
    }
    .container {
      position: relative;
      z-index: 1;
    }
  }
  .HeroImage_headline {
    text-align: left;
    color: #FFFFFF;
    margin: 0 0 15px 0;;
    font-size: 20px;
    line-height: 1.2;
    text-transform: uppercase;
    font-weight: 700;
    position: relative;
    z-index: 1;
    @media (min-width: 992px) {
      font-size: 36px;
      margin: 0 0 30px 0;;
    }
    @media (min-width: 1600px) {
      font-size: 42px;
    }
  }
  .HeroImage_subHeadline {
    text-align: left;
    color: ${colors.color2Dark};
    margin: 0;
    font-size: 20px;
    font-weight: 400;
    position: relative;
    z-index: 1;
    @media (min-width: 992px) {
      font-size: 30px;
    }
  }
  .HeroImage_vipButtonWrapper {
    position: absolute;
    right: 0;
    bottom: -60px;
    width: 53px;
    height: 58px;
    display: none;
    @media (min-width: 992px) {
      width: 204px;
      height: 225px;
      display: block;
    }
    div {
      width: 100%;
      height: 100%;
    }
    span {
      display: block;
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
  }
  .HeroImage_vipButton {
    width: 100%;
    height: 100%;
    background-image: url('/images/hbt-vip-logo.svg');
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .HeroImage {
    width: 100%;
    height: 280px;
    object-fit: cover;
  }
`;

function HeroImage({ builder }) {
  return (
    <div
      className={styles}
    >
      <div
        className="HeroImage_headlineWrapper"
      >
        <div className="container position-relative">
          <div className="row">
            <div className="col-lg-9 col-xl-7">
              <img
                src="/images/hbt-logo-rev.svg"
                alt="Homebuilder Tech"
                className="HeroImage_logo"
              />
              <h3 className="HeroImage_logoTagline">A Meeting of Digital Minds</h3>
              <h1 className="HeroImage_headline">
                A FREE Virtual Conference.<br />
                All in One Place, Online.
              </h1>
              <h2 className="HeroImage_subHeadline">
                June 25-26, 2020 • Anywhere
              </h2>
              <ContactModal builder={builder}>
                <div className="btn mt-4" role="button" tabIndex="0" >Registration Now Open!</div>
              </ContactModal>
            </div>
          </div>
        </div>
        <div className="row d-lg-none mt-5">
          <img src="/images/HBT-Tease-Mockup.jpg" className="HeroImage" alt="" />
        </div>
      </div>
    </div>
  );
}

HeroImage.propTypes = {
  builder: PropTypes.object.isRequired,
};

export default withData({
  builder: true,
})(HeroImage);



// WEBPACK FOOTER //
// ./src/pages/IndexPage/HeroImage.js